import { EventEmitter, Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class JournalTabService {
  public reloadJournalTab = new EventEmitter();
}
